import { render, staticRenderFns } from "./AddIntegrationItem.vue?vue&type=template&id=10110e77&scoped=true"
import script from "./AddIntegrationItem.vue?vue&type=script&lang=js"
export * from "./AddIntegrationItem.vue?vue&type=script&lang=js"
import style0 from "./AddIntegrationItem.vue?vue&type=style&index=0&id=10110e77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10110e77",
  null
  
)

export default component.exports